import React, { useEffect, useState } from "react";
import { Provider } from "react-redux";
import store from "./redux/store/store";

import "./App.css";

import GymRegistrationGymCreationForm from "./Container/GymRegistration/GymRegistrationGymCreationForm";
import LandingPage from "./Pages/LandingPage/LandingPage";
import RegistrationPage from "./Pages/RegistrationPage/RegistrationPage";
import AthleteRegistrationPage from "./Pages/AthleteRegistrationPage/AthleteRegistrationPage";

import { BrowserRouter, Switch, Route } from "react-router-dom";

import Login from "./Container/Login/Login";
import SubscribeGym from "./Container/SubscribeGym/SubscribeGym";
import ChatPage from "./Pages/ChatPage/ChatPage";
import ProgrammingCalendar from "./Container/ProgrammingCalendar/ProgrammingCalendar";
import ManageAthletes from "./Container/ManageAthletes/ManageAthletes";
import SuccessFail from "./Components/SuccessFail/SuccessFail";
import ForgotPassword from "./Container/ForgotPassword/ForgotPassword";
import ResetPassword from "./Components/ResetPassword/ResetPassword";
import MarketplaceTrackList from "./Container/MarketplaceTracksList/MarketplaceTrackList";
import Marketplace from "./Pages/Marketplace/Marketplace";

import SuccessScreen from "./Components/SuccessScreen/SuccessScreen";
import TrackJoiningPage from "./Container/TrackJoiningPage/TrackJoiningPage";
import ProtectedRotue from "./Components/ProtectedRoute/ProtectedRoute";
import StatsDashboard from "./Pages/StatsDashboard/StatsDashboard";
import { ErrorScreen } from "./Components/ErrorScreen/ErrorScreen";

import unauthorizedEntryImage from "./assets/Images/UnAuthorizedEntry.png";
import notfoundImage from "./assets/Images/404.png";
import { getUserInfo } from "./ApiHandlers/getUserInfo";
import ConnectWithStripe from "./Container/ConnectWithStripe/ConnectWithStripe";

function App() {
  const [areTrackLoading, setAreTracksLoading] = useState(false);

  useEffect(() => {
    getUserInfo();
  }, []);

  return (
    <>
      <Provider store={store}>
        <BrowserRouter>
          <Switch>
            <Route exact path="/" component={Login} />
            <Route exact path="/landingpage" component={LandingPage} />
            <Route
              exact
              path="/registrationform/:id"
              component={RegistrationPage}
            />
            <Route
              exact
              path="/gymregistrationgymcreationform/:id"
              component={GymRegistrationGymCreationForm}
            />
            <Route exact path="/login" component={Login} />
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />

            <Route
              exact
              path="/athleteaccountAditionalInfoform/:id"
              component={AthleteRegistrationPage}
            />
            <Route exact path="/marketplace" component={Marketplace} />
            <Route exact path="/newmarketplace" component={Marketplace} />
            <Route
              exact
              path="/marketplace/:id"
              component={MarketplaceTrackList}
            />
            <ProtectedRotue
              path="/trackjoiningpage"
              showNavbar={false}
              Component={TrackJoiningPage}
            />
            <ProtectedRotue
              path="/successpage"
              showNavbar={false}
              Component={SuccessScreen}
            />

            {/* dashboard */}
            <ProtectedRotue
              exact
              path="/dashboard"
              Component={StatsDashboard}
              otherProps={{
                setAreTracksLoading: setAreTracksLoading,
              }}
            />
            <ProtectedRotue
              exact
              path="/dashboard/programmingcalendar"
              Component={ProgrammingCalendar}
              otherProps={{
                trackLoading: areTrackLoading,
                setAreTracksLoading: setAreTracksLoading,
              }}
            />
            <ProtectedRotue
              exact
              path="/dashboard/manageathletes"
              Component={ManageAthletes}
              otherProps={{ setAreTracksLoading: setAreTracksLoading }}
            />
            <ProtectedRotue
              exact
              path="/dashboard/manageathletes/athletedetails/:athleteId"
              Component={StatsDashboard}
              otherProps={{
                key: Math.random(),
                setAreTracksLoading: setAreTracksLoading,
              }}
            />
            <ProtectedRotue
              exact
              path="/dashboard/subscribe"
              Component={SubscribeGym}
              otherProps={{ setAreTracksLoading: setAreTracksLoading }}
            />
            <ProtectedRotue
              exact
              path="/dashboard/connect"
              Component={ConnectWithStripe}
              otherProps={{ setAreTracksLoading: setAreTracksLoading }}
            />
            <ProtectedRotue
              exact
              path="/dashboard/congratulations/:id"
              Component={SuccessFail}
              otherProps={{ setAreTracksLoading: setAreTracksLoading }}
            />
            <ProtectedRotue
              exact
              path="/dashboard/messages"
              Component={ChatPage}
              otherProps={{ setAreTracksLoading: setAreTracksLoading }}
            />
            <Route
              exact
              path="/unauthorized"
              render={() => (
                <ErrorScreen scourceImage={unauthorizedEntryImage} />
              )}
            />
            {/* end */}

            <Route
              render={() => <ErrorScreen scourceImage={notfoundImage} />}
            />
          </Switch>
        </BrowserRouter>
      </Provider>
    </>
  );
}

export default App;
